import { getExplorationType } from '@/core/exploration';
import { CloseButton } from '@/components/button';
import { useLayoutContext } from '@/components/layout/layout-context';

import { SidebarSection } from '../../sidebar-section';
import { ExplorationSettings } from '../../settings';
import { ExplorationOutline } from '../../exploration-outline';
import { useExplorationContext } from '../../exploration-context';
import { useExplorationUIContext } from '../../exploration-ui-context';

import styles from '../sidebar.module.scss';

interface ExplorationSidebarProps {
  onAddSection: () => void;
}

export const ExplorationSidebar = (props: ExplorationSidebarProps) => {
  const { onAddSection } = props;

  const { exploration, moveCell } = useExplorationContext();
  const { openEditor, scrollToCell } = useExplorationUIContext();
  const { toggleRightSidebar } = useLayoutContext();

  return (
    <>
      <SidebarSection title="Settings">
        <CloseButton className={styles.collapseButton} onClick={() => toggleRightSidebar(false)} />
        <ExplorationSettings
          exploration={exploration}
          updateDisabled={getExplorationType(exploration) !== 'exploration'}
        />
      </SidebarSection>
      <SidebarSection title="Table of Contents" scrollable>
        <ExplorationOutline
          exploration={exploration}
          onClickCell={(cellId) => {
            openEditor(cellId);
            scrollToCell(cellId);
          }}
          onClickAddSection={onAddSection}
          onReorder={moveCell}
        />
      </SidebarSection>
    </>
  );
};
